// src/js/core/tooltip.js

import { getTranslation, removeTranslation } from "./translateWords.js";
import { getCurrentLanguage, getCurrentLanguageWords, updateCurrentLanguageWords } from "./wordManager.js";
import { updateUnknownWordsList } from "./wordListUI.js";

let tooltip;
let hideTooltipTimer;

function createTooltip() {
  const tooltipElement = document.createElement("div");
  tooltipElement.className = "word-tooltip";
  tooltipElement.style.display = "none";

  const translationText = document.createElement("div");
  translationText.className = "translation-text";

  const pronunciationText = document.createElement("div");
  pronunciationText.className = "pronunciation-text";

  const removeButton = document.createElement("button");
  removeButton.className = "know-word-button";
  removeButton.textContent = "Unsave";

  removeButton.addEventListener("click", (e) => {
    e.stopPropagation();
    const word = tooltipElement.dataset.currentWord;
    if (word) {
      const currentWords = getCurrentLanguageWords();
      currentWords.delete(word);
      updateCurrentLanguageWords(currentWords);
      removeTranslation(word, getCurrentLanguage());

      document.querySelectorAll(`.word[data-word="${word}"]`).forEach((el) => {
        el.classList.remove("unknown");
      });

      updateUnknownWordsList();
      hideTooltip();
    }
  });

  tooltipElement.appendChild(translationText);
  tooltipElement.appendChild(pronunciationText);
  tooltipElement.appendChild(removeButton);
  document.body.appendChild(tooltipElement);

  return tooltipElement;
}

function showLoadingTooltip(word, clickedElement) {
  if (!tooltip) return;

  if (hideTooltipTimer) {
    clearTimeout(hideTooltipTimer);
  }

  tooltip.dataset.currentWord = word;

  // Clear existing content and show spinner
  const translationText = tooltip.querySelector(".translation-text");
  const pronunciationText = tooltip.querySelector(".pronunciation-text");
  
  translationText.innerHTML = "";
  pronunciationText.textContent = "";
  
  const spinner = document.createElement("div");
  spinner.className = "spin";
  spinner.style.marginBottom = "0.25rem";
  translationText.appendChild(spinner);

  tooltip.style.display = "block";

  const rect = clickedElement.getBoundingClientRect();
  tooltip.style.left = `${rect.left}px`;
  tooltip.style.top = `${rect.bottom + 5}px`;
}

export function showTooltip(word, translationData, clickedElement) {
  if (!tooltip) return;

  if (hideTooltipTimer) {
    clearTimeout(hideTooltipTimer);
  }

  tooltip.dataset.currentWord = word;

  tooltip.querySelector(".translation-text").textContent = translationData.value || translationData;
  tooltip.querySelector(".pronunciation-text").textContent = translationData.pronunciation || "";

  tooltip.style.display = "block";

  const rect = clickedElement.getBoundingClientRect();
  tooltip.style.left = `${rect.left}px`;
  tooltip.style.top = `${rect.bottom + 5}px`;

  hideTooltipTimer = setTimeout(() => {
    hideTooltip();
  }, 2500);
}

export function hideTooltip() {
  if (!tooltip) return;

  if (hideTooltipTimer) {
    clearTimeout(hideTooltipTimer);
    hideTooltipTimer = null;
  }

  tooltip.style.display = "none";
  tooltip.dataset.currentWord = "";
}

export function initializeTooltip() {
  tooltip = createTooltip();

  document.getElementById("output").addEventListener("click", async (e) => {
    const wordElement = e.target.closest(".word.unknown");
    if (wordElement) {
      const word = wordElement.dataset.word;

      if (tooltip.style.display === "block" && tooltip.dataset.currentWord === word) {
        hideTooltip();
      } else {
        // Show loading tooltip immediately
        showLoadingTooltip(word, wordElement);
        
        const translationData = await getTranslation(word, getCurrentLanguage());
        if (translationData) {
          showTooltip(word, translationData, wordElement);
        } else {
          hideTooltip();
        }
      }
    }
  });

  document.addEventListener("click", (e) => {
    if (!e.target.closest(".word") && !e.target.closest(".word-tooltip")) {
      hideTooltip();
    }
  });

  document.addEventListener("scroll", () => {
    hideTooltip();
  });
}
